module.exports = __webpack_public_path__ + "img/ticket-details.f43f8c0c.svg";